export default "__VITE_ASSET__BbOxkabk__"